import { LocalDate } from '@js-joda/core';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, DatePicker, dayValidator } from '@dreryk/react-components';

import { medicalDocumentationCreateTranslationKeys } from '../../translations';

type DateFromDatePickerProps = FieldControllerProps<'dateFrom', LocalDate | undefined> &
   ClassNameProp & {
      readonly dateTo: LocalDate | undefined;
   };

export const DateFromDatePicker = (props: DateFromDatePickerProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <DatePicker
         testId={props.name}
         controller={controller}
         className={props.className}
         label={medicalDocumentationCreateTranslationKeys.dateFrom}
         dayValidators={[dayValidator.dayAfterToday(), dayValidator.dayAfterReferenceDay(props.dateTo)]}
         withNavigationArrows
      />
   );
};
